// Ticket ea99a2fa: a bracket is over once its championship has an official
// result. The server now flips brackets.status to 'complete' at that moment
// (sync_bracket_completion), but the cron used to wait for the tournament's
// end_date, so the header kept reading "Open for Picks" for hours after the
// final. This mirrors the server's bracket_results_final() so the UI agrees
// even if it loaded before the status flip landed.
//
// A terminal match is a non-pool match that feeds nowhere: the single-elim
// final, or every Sunday Finals match of a pool_then_sunday bracket. `picks` is
// the store's picks map keyed by match_id, where winner_team_id is the official
// result.
export function hasOfficialFinalResult(matches, picks) {
  if (!Array.isArray(matches) || !picks) return false
  const terminal = matches.filter(m => m && m.match_kind !== 'pool' && m.feeds_into_round == null)
  return terminal.length > 0 && terminal.every(m => !!picks[m.match_id]?.winner_team_id)
}
